<script>
import Layout from '@layouts/main.vue'
import analyticsService from '@utils/analytics-service'
import CustomTrackers from '@components/custom-trackers-list.vue'

export default {
  page: {
    title: 'Custom Trackers',
    meta: [{ name: 'description', content: 'The Custom Trackers page.' }],
  },
  components: { Layout, CustomTrackers },
  mounted() {
    analyticsService.trackPageView('Custom Trackers')
  },
}
</script>

<template>
  <Layout>
    <h3>Custom Trackers</h3>

    <CustomTrackers></CustomTrackers>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
</style>

